// extracted by mini-css-extract-plugin
export default {"placeholder":"CustomDatePickerInput_placeholder__Areme"};